<template>
  <div>
    <search></search>
    <div class="tableContainer"
         style="position:relative">
      <div id="blockListTop"
           class="blockList tableHeader">
        <table class="tableHead">
          <thead>
            <tr>
              <th v-for="(item,key) in tableHead"
                  :width='item.width'
                  :key="key"
                  @click='sortBy(item.key,sortObj.sortOrder);maidian(item.key)'>{{item.name}}</th>
            </tr>
            <div v-if="sortObj.arrowShow"
                 :style="arrowUpStyle"></div>
            <div v-if="sortObj.arrowShow"
                 :style="arrowDownStyle"></div>
          </thead>
        </table>
      </div>
      <div id="fixedName">名称</div>
      <div id="listContainer">
        <div class="blockList"
             @mouseout="selectHover('0')">
          <table>
            <tbody class="item-list">
              <tr v-for="(item,key) in hqData"
                  :key="key"
                  :class="{selected:item.key==selectedCode&&showSelectBlock,hoverStyle:item.key==hoverIndex}"
                  @click="changeCode(item.key)"
                  @dblclick="go2TimeLine(item.key)"
                  @mouseover="selectHover(item.key)">
                <td
                    class="code-name"
                    :title="item.zqmc">{{item.zqmc}}</td>
                <td
                    class="zhangdiefu"
                    :class="{cr:item.zhangdiefu>0 , cg:item.zhangdiefu<0}">{{format(item.zhangdiefu,'zhangdiefu')}}</td>
                <td class="risecount">
                  <span class="cr">{{format(item.risecount,'risecount')}}</span> /
                  <span class="cg">{{format(item.fallcount,'fallcount')}}</span>
                </td>
                <td
                    class="cr riselimitcount">{{format(item.riselimitcount,'riselimitcount')}}</td>
                <td
                    @click="go2TimeLine(item.ltggcode)" class="hidden-name" :title="item.ltgg">{{item.ltgg}}</td>
                <td
                    class="zlje"
                    :class="{cr:item['592890']>0 ,cg:item['592890']<0}">{{format(item['592890'],'592890')}}</td>
                <td
                    class="zhangshu"
                    :class="{cr:item['zhangshu']>0 , cg:item['zhangshu']<0}">{{format(item['zhangshu'],'zhangshu')}}</td>
                <td
                    class="ZHANGFU_5D"
                    :class="{cr:item['ZHANGFU_5D']>0 , cg:item['ZHANGFU_5D']<0}"
                    >{{format(item['ZHANGFU_5D'],'ZHANGFU_5D')}}</td>
              </tr>
            </tbody>
          </table>
          <div id="nameHead">
            <div id="scroll-content">
              <table>
                <tbody>
                  <tr v-for="(item,key) in hqData"
                      :key="key"
                      :class="{selected:item.key==selectedCode&&showSelectBlock,hoverStyle:item.key==hoverIndex}"
                      @click="changeCode(item.key)"
                      @dblclick="go2TimeLine(item.key)"
                      @mouseover="selectHover(item.key)">
                    <td width='100px'
                        class="hidden-name"
                        :title="item.zqmc">{{item.zqmc | subName}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div>
      <div class="hover-tip hover-tip-msg"
           id="hoverTipMsg">
        当前筛选列表中没有该板块
      </div>
    </div>

  </div>
</template>
<script>
import router from '@/router/index.js';
import search from '@/components/blockmaps/listSearch.vue';
import { setInterval, clearInterval, setTimeout } from 'timers';
const DEFAULT_SORT_STYLE = '4px solid #5F6267';
export default {
  name: 'blockList',
  components: {
    search
  },
  props: ['top10State'],
  created() {
    eventBus.$on('blockCode', this.handle);
    // eventBus.$on('selectStatus', this.renderScroll); //切换到右边的时候加载滚动条
    eventBus.$on('tab', this.handle2); //处理市场概览页面点击列表个股跳转
    eventBus.$on('moveToPlate', this.moveToPlate); //搜索跳转到板块
    eventBus.$on('showSelectBlock', this.checkSelectBlock); //点击概览时隐藏列表选中
    eventBus.$on('toggleSelectItem', this.updateSelect); //切换筛选
  },
  computed: {
    hotRecommendClick() {
      if (this.$store.state.hotRecommendClick === true) {
        this.selectedCode = '';
      }
      return this.$store.state.hotRecommendClick;
    }
  },

  mounted() {
    const self = this;
    let scrollColor = '#424242';
    if (window.theme == 'white') {
      scrollColor = '#777';
    }
    // $('#listContainer').niceScroll({
    //   cursorcolor: scrollColor,
    //   cursorborder: '1px solid ' + scrollColor, // 滚动条边框样式
    //   autohidemode: false,
    //   cursorwidth: '8px'
    // });
    document.getElementById('listContainer').onscroll = function(x) {
      // 列表滚动的过程中，不显示悬浮样式
      if (self.hoverIndex) {
        self.hoverIndex = null;
      }
      // 因为固定列和非固定列滚动有延迟不同步，在200%比例放大小比较明显，隐藏滚动过程中取消选中
      // 滚动结束再选中
      if (self.selectedCode && self.showSelectBlock) {
        self.showSelectBlock = false;
      }
      const left = document.getElementById('listContainer').scrollLeft * -1;
      const top = document.getElementById('listContainer').scrollTop * -1;
      $('#blockListTop').css('margin-left', left);
      $('#scroll-content').css('margin-top', top);
      if (self.timer) {
        window.clearTimeout(self.timer);
        self.timer = null;
      }
      // 列表滚动停止 选中之前选中的行
      const delay = 50;
      self.timer = window.setTimeout(() => {
        self.showSelectBlock = true;
      }, delay);
    };
    document.getElementById('nameHead').onmousewheel = function(e) {
      console.log('scroll22222');
      if (e.wheelDelta > 0) {
        document.getElementById('listContainer').scrollTop -= 130;
      } else {
        document.getElementById('listContainer').scrollTop += 130;
      }
    };
    self.getData();
  },
  beforeDestroy() {
    eventBus.$off('blockCode', this.handle);
    eventBus.$off('selectStatus', this.renderScroll);
    eventBus.$off('tab', this.handle2);
    eventBus.$off('moveToPlate', this.moveToPlate);
    eventBus.$off('showSelectBlock', this.checkSelectBlock);
    eventBus.$off('toggleSelectItem', this.updateSelect);
    clearInterval(this.interval);
  },
  data() {
    const transparent_border = '4px solid transparent';
    return {
      url: `//apigate.${window.Acme.getDomain()}/d/charge`,
      sortObj: {
        sortOrder: false,
        arrowShow: false
      },
      sortKey: 'zhangdiefu',
      selectedCode: '',
      showSelectBlock: false,
      hoverIndex: '',
      arrowUpStyle: {
        height: 0,
        width: 0,
        borderTop: transparent_border,
        borderLeft: transparent_border,
        borderRight: transparent_border,
        borderBottom: DEFAULT_SORT_STYLE,
        position: 'absolute',
        top: '6px'
      },
      arrowDownStyle: {
        height: 0,
        width: 0,
        borderTop: DEFAULT_SORT_STYLE,
        borderLeft: transparent_border,
        borderRight: transparent_border,
        borderBottom: transparent_border,
        position: 'absolute',
        top: '17px'
      },
      tableHead: [
        {
          name: '名称',
          width: '100px',
          key: 'zqmc'
        },
        {
          name: '涨幅%',
          width: '60px',
          key: 'zhangdiefu'
        },
        {
          name: '涨跌数',
          width: '80px',
          key: 'zhangdieshu'
        },
        {
          name: '涨停数',
          width: '60px',
          key: 'riselimitcount'
        },
        {
          name: '龙头个股',
          width: '75px',
          key: 'ltgg'
        },
        {
          name: '主力金额',
          width: '75px',
          key: '592890'
        },
        {
          name: '涨速%',
          width: '75px',
          key: 'zhangshu'
        },
        {
          name: '5日涨幅%',
          width: '75px',
          key: 'ZHANGFU_5D'
        }
      ],
      hqData: [],
      interval: null,
      location: 0, //在板块详情还是市场概览 0,1
      top10BlockCode: []
    };
  },
  watch: {
    top10State(newval, oldval) {
      if (!newval) {
        this.getData();
        return;
      }
      this.getTop10BlockCode();
    }
  },
  methods: {
    getTop10BlockCode() {
      $.ajax({
        url: `${this.url  }/hottrack/api/getcircleblocks`,
        xhrFields: {
          withCredentials: true
        },
        data: {
          'client-type': window.clientType,
          dayNum: 10
        },
        dataType: 'json',
        success: data => {
          if (data.errorcode === 0 && data.result) {
            const {result} = data;
            this.top10BlockCode = [];
            for (let i = 0; i < 10; i++) {
              this.top10BlockCode.push(Number(result.qs[i].stockcode));
            }
          }
          this.getData();
        }
      });
    },
    showTipMsg(msg) {
      if (msg) {
        $('#hoverTipMsg').fadeIn('normal', function() {
          $('#view_search_input')
            .attr('placeholder', '查找板块')
            .val('');
          $('#view_search_input')
            .siblings('i')
            .removeClass('delete');
          setTimeout(function() {
            $('#hoverTipMsg').fadeOut();
          }, 1800);
        });
      }
    },
    updateSelect() {
      if (this.top10State) {
        this.getTop10BlockCode();
        return;
      }
      this.getData();
    },
    checkSelectBlock(index) {
      if (index == 0) {
        this.showSelectBlock = false;
      } else {
        this.showSelectBlock = true;
      }
    },
    handle(val) {
      this.selectedCode = val;
    },
    handle2(val) {
      this.location = val;
    },
    moveToPlate(val) {
      const s = this;
      for (let i = 0; i < s.hqData.length; i++) {
        if (s.hqData[i].key === val) {
          setTimeout(function() {
            s.changeCode(val);
          }, 500);
          $('#listContainer').scrollTop(30 * i);
          s.selectedCode = val;
          break;
        }
        if (i == s.hqData.length - 1) {
          //遍历结束没有找到节点
          s.showTipMsg('抱歉：当前筛选列表中没有该板块');
        }
      }
      // console.log(this.hqData[0]);
    },
    selectHover(val) {
      this.hoverIndex = val;
    },
    maidian(key) {
      const self = this;
      if (key == 'zqmc' || key == 'ltgg' || key == 'zhangdieshu') {
        return;
      } else if (key == 'zhangdiefu') {
        TA.log({ id: 'L2rdzz_5a77f088_580' });
      } else if (key == 'huanshou') {
      } else if (key == '592890') {
        TA.log({ id: 'L2rdzz_5a77f129_184' });
      } else if (key == 'riselimitcount') {
        TA.log({ id: 'L2rdzz_5a77f0d7_697' });
      } else if (key == 'zhangshu') {
        TA.log({ id: 'L2rdzz_5a77f17d_747' });
      } else if (key == 'ZHANGFU_5D') {
        TA.log({ id: 'L2rdzz_5a77f1b4_625' });
      }
      $('#listContainer').scrollTop(0);
    },
    // renderScroll(val) {
    //   console.log('影藏', val);
    //   if (val === 1) {
    //     this.$nextTick(() => {
    //       $('#listContainer')
    //         .getNiceScroll()
    //         .resize();
    //     });
    //   } else {
    //     setTimeout(() => {
    //       console.log('英才踩踩踩');
    //       $('#listContainer')
    //         .getNiceScroll()
    //         .hide();
    //     }, 50);
    //   }
    // },
    getData() {
      const self = this;
      $.ajax({
        url: `${self.url  }/hottrack/service/stocklead`,
        xhrFields: {
          withCredentials: true
        },
        data: {
          'client-type': window.clientType
        },
        dataType: 'jsonp',
        success(data) {
          const platecodes = [];
          const stocktaps = [];
          const mappingTable = {};
          if (self.top10State) {
            for (var i = 0; i < data.result.length; i++) {
              if (self.top10BlockCode.indexOf(data.result[i].platecode) !== -1) {
                mappingTable[data.result[i].platecode] = data.result[i];
                platecodes.push(data.result[i].platecode);
                stocktaps.push(data.result[i].stocktap);
              }
            }
          } else {
            for (var i = 0; i < data.result.length; i++) {
              mappingTable[data.result[i].platecode] = data.result[i];
              platecodes.push(data.result[i].platecode);
              stocktaps.push(data.result[i].stocktap);
            }
          }

          clearInterval(self.interval);

          self.interval = window.$util.userInterval(() => {
            self.getHqData(platecodes, mappingTable);
          }, 5000);
          self.getHqData(platecodes, mappingTable);
        }
      });
    },
    getHqData(platecodes, mappingTable) {
      Acme.getHqData(
        {
          code: platecodes,
          type: [
            'zqmc',
            'zhangdiefu',
            'risecount',
            'fallcount',
            '271',
            '592890',
            'zhangshu',
            'wrzf',
            'ZHANGFU_5D'
          ],
          period: 'now',
          mode: 'after'
        },
        data => {
          this.renderListData(data, mappingTable);
        }
      );
    },
    renderListData(data, mappingTable) {
      const self = this;
      const sortArr = [];
      try {
        for (const key in data) {
          const element = {};
          element.key = key;
          element.zqmc = data[key].zqmc;
          element.zhangdiefu = data[key].zhangdiefu;
          element.risecount = data[key].risecount;
          element.fallcount = data[key].fallcount;
          element.riselimitcount = data[key]['271'];
          element['592890'] = Number(data[key]['592890']);
          element['zhangshu'] = data[key]['zhangshu'];
          element['ZHANGFU_5D'] = data[key]['ZHANGFU_5D'];
          element.ltgg = mappingTable[key].stocktap;
          element.ltggcode = mappingTable[key].stockcode;
          sortArr.push(element);
        }
      } catch (e) {
        console.log(e.message);
      }
      self.hqData = sortArr;

      self.sortBy(self.sortKey, 'notchange');
      // console.log('走了这个隐藏');
      // self.renderScroll(1);
      // if (window.theme === 'white') {
      //   console.log('white')
      //   $('#listContainer tbody tr').css({
      //     'border-bottom': '1px solid #595959'
      //   })
      // } else {
      //   $('#listContainer tbody tr').css({
      //     'border-bottom': '1px solid #282828'
      //   })
      // }
    },
    format(num, type) {
      if (num == 'NUL' || isNaN(num)) {
        return '--';
      }

      if (type == 'risecount' || type == 'fallcount' || type == 'riselimitcount') {
        return num;
      }
      if (type == 'new') {
        return Acme.toFixed(num, 2);
      } else if (type == 'zhangdiefu' || type == 'ZHANGFU_5D' || type == 'zhangshu') {
        if (num > 0) {
          return `+${  Acme.toFixed(num, 2)}`;
        } else {
          return Acme.toFixed(num, 2);
        }
      } else if (type == 'huanshou') {
        return Acme.toFixed(num, 2);
      } else if (type == '592888') {
        return Acme.toFixed(num, 2);
      } else if (type == '592890') {
        if (Math.abs(num) > 10000000) {
          return `${Acme.toFixed(num / 100000000, 2)  }亿`;
        } else if (Math.abs(num) > 10000) {
          return `${Acme.toFixed(num / 10000, 2)  }万`;
        }
      }
    },
    sortBy(key, order) {
      const self = this;
      if (key == 'zqmc' || key == 'ltgg' || key == 'zhangdieshu') {
        return;
      }
      self.changeArrowStyle(key);
      // console.log(key,order);
      if (order !== 'notchange') {
        self.arrowDownStyle.borderTop = order ? '4px solid #108AED' : DEFAULT_SORT_STYLE;
        self.arrowUpStyle.borderBottom = order ? DEFAULT_SORT_STYLE : '4px solid #108AED';
        self.sortObj.arrowShow = true;
        // self.sortObj.sortOrder = self.$set(self.sortObj,'sortOrder',!self.sortObj.sortOrder);
        self.sortObj.sortOrder = !order;
        self.sortKey = key || 'zhangdiefu';
        self.hqData = Object.assign([], Acme.sort(this.hqData, !order, key));
      } else {
        order = self.sortObj.sortOrder;
        self.hqData = Object.assign([], Acme.sort(this.hqData, order, key));
      }

      // Acme.sort(this.hqData,order,key);
    },
    changeArrowStyle: function(key) {
      if (key === 'zhangdiefu') {
        this.arrowDownStyle.left = '150px';
        this.arrowUpStyle.left = '150px';
      } else if (key === 'huanshou') {
        this.arrowDownStyle.left = '280px';
        this.arrowUpStyle.left = '250px';
      } else if (key === '592890') {
        this.arrowDownStyle.left = '440px';
        this.arrowUpStyle.left = '440px';
      } else if (key === 'riselimitcount') {
        this.arrowDownStyle.left = '290px';
        this.arrowUpStyle.left = '290px';
      } else if (key === 'zhangshu') {
        this.arrowDownStyle.left = '514px';
        this.arrowUpStyle.left = '514px';
      } else if (key === 'ZHANGFU_5D') {
        this.arrowDownStyle.left = '589px';
        this.arrowUpStyle.left = '589px';
      } else {
        return;
      }
    },
    go2TimeLine: function(code) {
      Acme.go2TimeLine(code);
    },
    emitBlockCode(code) {
      eventBus.$emit('blockCode', code);
      this.$store.dispatch({
        type: 'setActiveBlock',
        blockCode: code
      });
    },
    changeCode(code) {
      const self = this;
      if (code == this.selectedCode && this.location == 1) {
        return;
      }
      if (self.location !== 2 && self.location !== 1) {
        if (window.clientType === 2) {
          router.push('/hotAnalysis');
          eventBus.$emit('tab', 2);
          // self.location = 2;
        } else {
          router.push('/blockDetail');
          eventBus.$emit('tab', 1);
          // self.location = 1;
        }
      }
      // router.push('/blockDetail');
      // self.location = 1;
      self.selectedCode = code;
      eventBus.$emit('ListStatus', code); //将板块列表状态传递到父级...然后形成了一个循环 板块列表->父级->板块地图->板块列表
      setTimeout(function() {
        self.emitBlockCode(code);
        // eventBus.$emit('blockCode', code);
      }, 300);
      eventBus.$emit('url', this.location);
      self.checkSelectBlock(1);
      TA.log({ id: 'L2rdzz_5a77f1f8_499' });
    }
  },
  filters: {
    subName(value) {
      return value.length > 6 ? `${value.substring(0, 6)  }...` : value;
    }
  }
};
</script>
<style scoped>
* {
  box-sizing: border-box;
}

#listContainer {
  width: 305px;
  /* position: relative; */
  height: 455px;
  overflow: auto;
}

.blockList table tr .pr-20 {
  padding-right: 20px;
}

table {
  border-collapse: collapse;
  width: 600px;
}

.tableHeader {
  overflow: hidden;
}

.blockList table tr th {
  font-size: 12px;
  color: #a0a0a0;
  text-align: right;
  font-weight: normal;
  padding-right: 12px;
  padding-left: 0px;
  height: 28px;
  line-height: 28px;
  cursor: pointer;
}

.blockList table tr th:nth-child(1) {
  text-align: left;
  padding-left: 12px;
  cursor: default;
  padding-right: 0px;
  /* visibility: hidden; */
}

.blockList table tr th:nth-child(3) {
  cursor: default;
}

.blockList table tr td {
  /* box-sizing: border-box; */
  font-size: 12px;
  color: white;
  text-align: right;
  padding-right: 12px;
  padding-left: 0px;
  font-weight: normal;
  cursor: default;
  height: 27px;
  line-height: 27px;
}

.blockList table tr td:nth-child(1) {
  text-align: left;
  padding-left: 12px;
  /* visibility: hidden;    */
  padding-right: 0px;
  /* padding-right: 0;  */
}

.blockList table tr td:nth-child(5):hover {
  text-decoration: underline;
  cursor: pointer;
}

.tableHead {
  position: relative;
}
.tableHead tr {
  background: #2a2a2a;
}
.white .tableHead tr {
  background: #434343;
}

.blockList .cr {
  color: #d6524d;
}

.blockList .cg {
  color: #1cbf7b;
}

#listContainer .selected {
  background-color: #0d2a4a;
}
.white #listContainer .selected {
  background-color: #354c82;
}

#nameHead {
  position: absolute;
  /* top: 0; */
  top: 30px;
  width: 97px;
  height: 449px;
  overflow: hidden;
  background-color: #1b1b1b;
}

.white #nameHead {
  background-color: #4a4a4a;
}

#nameHead table tr td:nth-child(1) {
  visibility: visible;
}

.hoverStyle {
  background-color: #333333;
}

.white .hoverStyle {
  background-color: #595959;
}

#fixedName {
  width: 100px;
  background-color: #2a2a2a;
  position: absolute;
  top: 0px;
  font-size: 12px;
  color: #a0a0a0;
  text-align: left;
  font-weight: normal;
  padding-right: 12px;
  padding-left: 12px;
  height: 28px;
  line-height: 28px;
  cursor: default;
}

.white #fixedName {
  background-color: #434343;
}

/* 新添加的样式*/
tbody tr {
  border-bottom: 1px solid #282828;
}

.white tbody tr {
  border-bottom: 1px solid #595959;
}

.hover-tip-msg {
  position: absolute;
  display: none;
  width: 160px;
  background: #fff;
  padding: 5px 9px;
  border: 1px solid #7d7d7d;
  border-radius: 6px;
  cursor: default;
  font-size: 12px;
  border: 1px solid #ac0000;
  color: #ac0000;
  left: 50%;
  margin-left: -80px;
  top: 100px;
}

.hidden-name {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

#listContainer table {
  table-layout: fixed;
}
.blockList .code-name {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  padding-right: 0;
}
.item-list tr .code-name {
  width: 100px;
}
.item-list tr .zhangdiefu {
  width: 60px;
}
.item-list tr .risecount {
  width: 80px;
}
.item-list tr .riselimitcount {
  width: 60px;
}
.item-list tr .hidden-name {
  width: 75px;
}
.item-list tr .zlje {
  width: 75px;
}
.item-list tr .zhangshu {
  width: 75px;
}
.item-list tr .ZHANGFU_5D {
  width: 75px;
}
</style>



// WEBPACK FOOTER //
// src/components/blockmaps/blockList.vue